export const CLEAR_FORM = 'CLEAR_FORM'
export const SET_TICKETID = 'SET_TICKETID'
export const UNSET_TICKETID = 'UNSET_TICKETID'
export const UPDATE = 'UPDATE'
export const RESET = 'RESET'
export const CLEAR_MESSAGE = 'CLEAR_MESSAGE'
